<template>
    <div id="menu-tab-area" class="normalTabArea">
        <div v-show="store.state.hasBooted" title="Exit Menu"
            class="return-to-canvas-button" @click="returnToCanvas()">
            <span class="material-icons menu-tab-icon">chevron_left</span>
            <span class="menu-tab-title">{{t('exit menu','Exit Menu')}}</span>
        </div>
        <div
            v-for="(item, index) in tabs" :key="index"
            v-show="item.showIf()"
            :title="item.title"
            @click="openTab(item)"
            :class="{active: store.state.currentTab === item.title}"
        >
            <span class="material-icons menu-tab-icon">{{ item.icon }}</span>
            <span class="menu-tab-title">{{ t(item.translationKey, item.title) }}</span>
        </div>
        <input ref="loadProject" id="load-project" type="file" @change="upload" accept=".bead" multiple/>
    </div>
</template>

<script>

import { lang } from '../../myapp/src/lang';
import { project } from '../../myapp/src/projects/project';
export default {
    name: 'Navigation',
    data() {
        return {
            tabs: [
                {
                    title: 'Upgrade',
                    showIf: () => this.store.state.loggedIn && b3.willMigrate,
                    icon: 'upgrade',
                    translationKey: 'upgrade tab'
                },
                {
                    title: 'File',
                    showIf: () => this.store.state.loggedIn && !b3.willMigrate,
                    icon: 'folder',
                    translationKey: 'my projects tab',
                    fn() {
                        b3.ee.emit('myProjectsActivated');
                    }
                },
                {
                    title: 'New',
                    showIf: () => !b3.willMigrate,
                    icon: 'add',
                    translationKey: 'new project tab',
                    isButton: true,
                    fn() {
                        b3.ee.emit('resetNewProjectModal');
                        b3.store.mySet('showingModal', 'new');
                    }
                },
                {
                    title: 'Edit',
                    showIf: () => this.store.state.hasBooted,
                    icon: 'edit',
                    translationKey: 'edit project tab',
                    fn() {
                        b3.ee.emit('resetEditProjectModal');
                    }
                },
                {
                    title: 'Palette',
                    showIf: () => this.store.state.hasBooted,
                    icon: 'palette',
                    translationKey: 'palette project tab'
                },
                {
                    title: 'Settings',
                    showIf: () => this.store.state.hasBooted,
                    icon: 'settings',
                    translationKey: 'settings tab'
                },
                {
                    title: 'Upload',
                    showIf: () => this.store.state.loggedIn && !b3.willMigrate,
                    icon: 'upload',
                    translationKey: 'upload',
                    isButton: true,
                    fn: () => {
                        this.$refs.loadProject.click();
                    }
                },
                {
                    title: 'Export',
                    showIf: () => this.store.state.loggedIn && this.store.state.hasBooted,
                    icon: 'ios_share',
                    translationKey: 'export tab',
                    fn() {
                        b3.ee.emit('clearWaitMessage');
                    }
                },
                {
                    title: 'Help',
                    showIf: () => this.store.state.hasBooted,
                    icon: 'help',
                    translationKey: 'help tab'
                }
            ]
        }
    },
    methods: {
        openTab({title, fn, isButton}) {
            if (fn) fn();
            if (!isButton) {
                this.store.mySet('currentTab', title);
            }
        },
        returnToCanvas() {
            b3.menu.returnToCanvas();
        },
        upload() {
            project.upload();
        }
    },
}

</script>

<style lang="scss">
@import '../../assets/colors.scss';

$sidebar_color: #4f9dbe;
$sidebar_text: white;
$sidebar_hover: #377d9b;
$sidebar_highlight: #27617a;

.return-to-canvas-button {
    background-color: $sidebar_color;
    &:hover {
        background-color: $b_theme_hover !important;
    }
}

.active {
    background-color: $sidebar_highlight;
    color: white;
    &:hover {
        background-color: $sidebar_highlight !important;
        cursor: default !important;
    }
}

#menu-tab-area {
    div {
        cursor: pointer;
        padding: 7px;
        transition: 0.3s;
        &:hover {
            background-color: $sidebar_hover;
        }
        .menu-tab-icon {
            position: relative;
            top: 2px;
        }
        .menu-tab-title {
            margin-left: 10px;
            font-size: 1em;
            position: relative;
            top: -4px;
        }
    }
    position: fixed;
    overflow: hidden;
    float: left;
    background-color: $sidebar_color;
    height: 100%;
    color: $sidebar_text;
    font-weight: bold;
    z-index: 0.9;
}

.normalTabArea {
    width: 180px;
}

@media only screen and (max-width: 875px) {
    #menu-tab-area {
        width: 40px;
    }
    #menu-tab-area div span:last-of-type {
        display: none;
    }
}
#load-project {
    display: none;
}

</style>